import { Injectable, inject } from '@angular/core';

import { Observable, map } from 'rxjs';

import { BestOddsGuaranteedToken } from '../../../betslip/modules/reward-tokens/reward-tokens.model';
import { BestOddsFixtureLikeInput } from '../models/models';
import { BestOddsGuaranteedService } from './best-odds-guaranteed.service';
import { BogTokenProviderService } from './bog-token-provider.service';
import { FixtureBestOddsGuaranteedTokenValidatorService } from './fixture-best-odds-guaranteed-token-validator.service';

@Injectable({ providedIn: 'root' })
export class TokenBasedBestOddsGuaranteedService extends BestOddsGuaranteedService {
    private tokenProvider = inject(BogTokenProviderService);
    private tokenValidator = inject(FixtureBestOddsGuaranteedTokenValidatorService);

    isFixtureEligible(fixture: BestOddsFixtureLikeInput): Observable<boolean> {
        return this.tokenProvider.tokens$.pipe(
            map((tokens: BestOddsGuaranteedToken[]) => {
                return !!tokens.length && tokens.some((token) => this.tokenValidator.validate(token, fixture));
            }),
        );
    }
}
